<template>
  <form
    autocomplete="off"
    class="gap-0 gap-y-4 "
    @submit.prevent="submitForm"
  >
    <div class="col-span-12 max-w-md mx-auto text-center">
      <h2 class="m-0">
        Account Verification
      </h2>

      <span class="text-secondary mb-6 block">
        Enter Your Cellphone Number
      </span>

      <span class="mb-8 block">
        Please enter your cellphone number to receive a One-Time Password (OTP) for account verification.
      </span>

      <TextInput
        v-model="formData.phoneNumber"
        label="Cellphone Number"
        required
        class="mb-8"
        :validation-error="errors"
        autofocus
      />

      <AppButton
        :processing="isSubmitting || cooldown !== 0"
        class="btn btn-solid py-2.5 w-full mb-6"
        :class="{'btn-gray': (cooldown > 0), 'btn-secondary': (cooldown < 1), }"
      >
        {{ cooldown === 0 ? 'Send OTP' : `Retry in ${cooldown}s` }}
      </AppButton>

      <template v-if="error">
        <span class="text-red-500 p-2 bg-red-100 rounded w-full block">
          {{ error }}
        </span>
      </template>
    </div>
  </form>
</template>

<script setup>
import { HttpStatusCode } from 'axios';
import { reactive, ref } from 'vue';

import { AppButton } from '@/components/app';
import { TextInput } from '@/components/forms/inputs';

import { useFormSubmit, useHttp } from '@/composables';
import { useAuthStore } from '@/store';

const { errors, error } = useFormSubmit();

const emit = defineEmits(['confirm']);

const cooldown = ref(0);
const authStore = useAuthStore();

const formData = reactive({
  phoneNumber: import.meta.env.DEV ? '0123456789' : null,
});

const phoneNumber = defineModel('phoneNumber');
const isSubmitting = defineModel('isSubmitting');

const submitForm = async () => {
  errors.value = null;
  error.value = null;
  isSubmitting.value = true;

  let validFormData = { ...formData };
  validFormData.phoneNumber = formData.phoneNumber.replace(/ /g, '');

  const response = await useHttp().post('/profile/verification', validFormData);

  if (response.statusCode === HttpStatusCode.Ok) {
    authStore.user.phoneNumber = formData.phoneNumber;
    phoneNumber.value = formData.phoneNumber;

    emit('confirm');
  } else if (response.statusCode === HttpStatusCode.UnprocessableEntity) {
    errors.value = response.errors.phoneNumber[0];
  } else if (response.statusCode === HttpStatusCode.TooManyRequests) {
    error.value = response.exception;

    cooldown.value = error.value.replace(/.*?(\d+).*/, '$1');
    error.value = error.value.split('.')[0];

    while (cooldown.value > 0) {
      await new Promise(resolve => {
        setTimeout(() => {
          cooldown.value -= 1;

          resolve();
        }, 1000);
      });
    }
  } else {
    errors.value = response.exception;
  }

  isSubmitting.value = false;
};
</script>
